import { Row, Col, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useState } from "react";
import { BadgeFitprenda, InputSearch, PushButtonFilter } from "../index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { E_ClothesType, E_GenderType } from "../types";
import ButtomAction from "./ButtonAction";
import "./SizeGuideGrid.css";
import { FormattedMessage } from "react-intl";
import { faBan } from "@fortawesome/free-solid-svg-icons";

const DataTableSizeGuides = (props: any) => {
  const { elements } = props;
  // let showOptions: boolean = false;

  // console.log('DataTableSizeGuides', elements);

  const [filters, setFilters] = useState<any>({
    global: { value: null, matchMode: "contains" },
  });

  const [selection, setSelection] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState("");

  // const [showOptions, setShowOptions] = useState(false);
  // const [target, setTarget] = useState(null);
  // const [targetDataProduct, setTargetDataProduct] = useState<any>(null);

  const [isFilterTop, setIsFilterTop] = useState(false);
  const [isFilterBottom, setIsFilterBottom] = useState(false);
  const [isFilterEntire, setIsFilterEntire] = useState(false);
  const [isFilterBrassiere, setIsFilterBrassiere] = useState(false);

  const [isFilterFemale, setIsFilterFemale] = useState(false);
  const [isFilterMale, setIsFilterMale] = useState(false);

  // const [filters, setFilters] = useState({
  //     'global': { value: null, matchMode: 'contains'}
  // });

  // useEffect(() => {
  //   initGlobalFilters();
  // }, []);

  // const initGlobalFilters = () => {
  //   setFilters({
  //     global: { value: null, matchMode: "contains" },
  //   });

  //   // {value: null, matchMode: 'contains'}
  // };

  /* DEFINIMOS PLANES */

  interface RowData {
    Enabled: boolean;
  }

  const renderRowStatus = (rowData: RowData) => {
    if (!rowData.Enabled) {
      return (
        <div className="d-flex justify-content-center align-items-center h-100">
          <FontAwesomeIcon icon={faBan} className="text-danger" />
        </div>
      );
    } else {
      return null;
    }
  };

  const onSelectionChange = (row: any) => {
    setSelection(row.value);

    if (props.handlerSelectionRow) props.handlerSelectionRow(row.value);
  };

  const onSearch = (value: any) => {
    let _filters = { ...filters };
    _filters["global"].value = value;

    console.log("_Filters", _filters);
    console.log("Valor", value);

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const onSearchSuperior = (state: any) => {
    let _filters = { ...filters };
    let value: string = "";

    if (!isFilterTop) value = "Superiores";

    _filters["global"].value = value;

    setIsFilterBottom(false);
    setIsFilterEntire(false);
    setIsFilterBrassiere(false);
    setIsFilterTop(!isFilterTop);

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const onSearchInferior = (state: any) => {
    let _filters = { ...filters };
    let value: string = "";

    if (!isFilterBottom) value = "Inferiores";

    _filters["global"].value = value;

    setIsFilterTop(false);
    setIsFilterEntire(false);
    setIsFilterBrassiere(false);
    setIsFilterBottom(!isFilterBottom);

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const onSearchEntera = (state: any) => {
    let _filters = { ...filters };
    let value: string = "";

    if (!isFilterTop) value = "Enteras";

    _filters["global"].value = value;

    setIsFilterBottom(false);
    setIsFilterTop(false);
    setIsFilterBrassiere(false);
    setIsFilterEntire(!isFilterEntire);

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const onSearchBrassiere = (state: any) => {
    let _filters = { ...filters };
    let value: string = "";

    if (!isFilterTop) value = "Brassiere";

    _filters["global"].value = value;

    setIsFilterBottom(false);
    setIsFilterTop(false);
    setIsFilterEntire(false);
    setIsFilterBrassiere(!isFilterBrassiere);

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const onSearchFemenino = (state: any) => {
    let _filters = { ...filters };
    let value: string = "";

    if (!isFilterFemale) value = "Femenino";

    _filters["global"].value = value;

    setIsFilterMale(false);
    setIsFilterFemale(!isFilterFemale);

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const onSearchMasculino = (state: any) => {
    let _filters = { ...filters };
    let value: string = "";

    if (!isFilterMale) value = "Masculino";

    _filters["global"].value = value;

    setIsFilterFemale(false);
    setIsFilterMale(!isFilterMale);

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const onClickEdit = (rowData: any) => {
    try {
      // console.log('DataTableSizeGuides Popover Edit', { data: rowData});

      if (props.handlerEdit) props.handlerEdit(rowData);

      // setTarget(null);
      // setTargetDataProduct(null);
    } catch (error) {
      console.log(error);
    }
  };

  const onClickClone = (rowData: any) => {
    try {
      // console.log('DataTableSizeGuides Popover Clone', { data: rowData});

      if (props.handlerClone) props.handlerClone(rowData);
    } catch (error) {
      console.log(error);
    }
  };

  const onClickDelete = (rowData: any) => {
    try {
      // console.log('DataTableSizeGuides Popover Delete', { data: rowData});

      if (props.handlerDelete) props.handlerDelete(rowData);
    } catch (error) {
      console.log(error);
    }
  };

  const onClickDeleteGroup = (data: any) => {
    try {
      // console.log('DataTableSizeGuides Popover Delete', { data: rowData});

      if (props.handlerDeleteGroup) props.handlerDeleteGroup(data);
    } catch (error) {
      console.log(error);
    }
  };

  const onClickDownload = (data: any) => {
    try {
      if (props.handlerDownload) props.handlerDownload(data);
    } catch (error) {
      console.log(error);
    }
  };

  // const renderActionRow = (rowData: any, event: any) => {
  //   // console.log('renderActionRow SizeGuideGrid Params', { RowData: rowData, Event: event });
  //   // console.log('renderActionRow SizeGuideGrid Selection', selection);
  //   // console.log('renderActionRow SizeGuideGrid Event', event);

  //   return (
  //     <>
  //       <div className="text-start">
  //       {/* <Button type="button" className="rounded" size="sm" onClick={(e: any) => handleClick(e, rowData)}>
  //         <FontAwesomeIcon icon={'pen'} className="text-dark" />
  //       </Button> */}
  //         <FontAwesomeIcon icon={"ellipsis-v"} onClick={(e) => handleClick(e, rowData)} />
  //         <Overlay
  //           show={showOptions}
  //           target={target}
  //           placement={"left"}
  //           containerPadding={20}
  //           rootClose={false}
  //         >
  //           <Popover>
  //             <Popover.Body>
  //             { props.handlerEdit ?
  //                   <>
  //                     <Row className="action-button" onClick={(event: any) => onClickEdit(event)}>
  //                       <Col xs={1}>
  //                         <FontAwesomeIcon icon={"pen"} />
  //                       </Col>
  //                       <Col>
  //                         <span>Editar</span>
  //                       </Col>
  //                     </Row>
  //                   </>
  //                   : <></>
  //               }
  //               {props.handlerClone ?
  //                 <>
  //                   <hr className="nav-side-divider" />
  //                   <Row className="action-button" onClick={(event: any) => onClickClone(event)}>
  //                     <Col xs={1}>
  //                       <FontAwesomeIcon icon={"clone"} />
  //                     </Col>
  //                     <Col>
  //                       <span>Duplicar</span>
  //                     </Col>
  //                   </Row>
  //                 </>
  //                 : <></>
  //               }
  //               {props.handlerDelete ? (
  //                 <>
  //                   <hr className="nav-side-divider" />
  //                   <Row className="action-button" onClick={(event: any) => onClickDelete(event)}>
  //                     <Col xs={1}>
  //                       <FontAwesomeIcon icon={"trash-alt"} />
  //                     </Col>
  //                     <Col>
  //                       <span>
  //                         Eliminar
  //                       </span>
  //                     </Col>
  //                   </Row>
  //                 </>
  //               ) : (
  //                 <></>
  //               )}
  //             </Popover.Body>
  //           </Popover>
  //         </Overlay>
  //       </div>
  //     </>
  //   );
  // };

  const renderHeader = () => {
    var qSuperior: number = 0;
    var qInferior: number = 0;
    var qEntera: number = 0;
    var qBrassiere: number = 0;
    var qFemenino: number = 0;
    var qMasculino: number = 0;

    if (
      props.elements &&
      (props.elements.length || 0) > 0 &&
      !props.isLoading
    ) {
      qSuperior =
        props.elements.filter((element: any) => {
          return (element.TypeSizeGuide?.Id || 0) === E_ClothesType.TOP;
        }).length || 0;
      qInferior =
        props.elements.filter((element: any) => {
          return (element.TypeSizeGuide?.Id || 0) === E_ClothesType.BOTTOM;
        }).length || 0;
      qEntera =
        props.elements.filter((element: any) => {
          return (element.TypeSizeGuide?.Id || 0) === E_ClothesType.ENTIRE;
        }).length || 0;
      qBrassiere =
        props.elements.filter((element: any) => {
          return (element.TypeSizeGuide?.Id || 0) === E_ClothesType.BRASSIERE;
        }).length || 0;
      qFemenino =
        props.elements.filter((element: any) => {
          return (element.Gender?.Id || 0) === E_GenderType.FEMALE;
        }).length || 0;
      qMasculino =
        props.elements.filter((element: any) => {
          return (element.Gender?.Id || 0) === E_GenderType.MALE;
        }).length || 0;

      // console.log('DataTableSizeGuides renderHeader', {
      //   Superior: qSuperior,
      //   Inferior: qInferior,
      //   Entera: qEntera,
      //   Brassiere: qBrassiere,
      //   Femenino: qFemenino,
      //   Masculino: qMasculino
      // });
    }

    // var colsSearch: number = 2;

    // if (!props.handlerDelete) colsSearch++;
    // if (!props.handlerEdit) colsSearch++;
    // if (!props.handlerAddSizeGuide) colsSearch += 2;
    // if (!props.handlerDownload) colsSearch++;

    return (
      <>
        <Row className="justify-content-center">
          <div className="size-guide-grid-nav-container">
            <div className="size-guide-grid-title-button-container">
              <Col className="text-left size-guide-grid-title-button-container-col">
                {props.showTitle ? (
                  <p className="font-fitprenda-section-title">
                    <FormattedMessage
                      id="size-guides-created-title"
                      // defaultMessage="Mis guías creadas"
                    />{" "}
                    <BadgeFitprenda
                      value={props.elements?.length || 0}
                      variant={"success"}
                    />
                  </p>
                ) : (
                  <></>
                )}
              </Col>

              {/* <Col xs={1} className="text-end">
            <Button type="button" variant="outline-success" size="sm">
              <FontAwesomeIcon icon={'file-excel'} />
            </Button>
          </Col> */}
              <div className="size-guide-grid-buttons-container">
                {qSuperior && (qInferior || qEntera || qBrassiere) ? (
                  <Col className="sizeguide-filter-button" xs={1}>
                    <PushButtonFilter
                      title={<FormattedMessage id="ready-size-superior" />}
                      quantity={qSuperior}
                      StateFilter={isFilterTop}
                      ClickSuscribe={onSearchSuperior}
                    />
                  </Col>
                ) : (
                  <></>
                )}
                {qInferior && (qSuperior || qEntera || qBrassiere) ? (
                  <Col className="sizeguide-filter-button" xs={1}>
                    <PushButtonFilter
                      title={<FormattedMessage id="ready-size-inferior" />}
                      quantity={qInferior}
                      StateFilter={isFilterBottom}
                      ClickSuscribe={onSearchInferior}
                    />
                  </Col>
                ) : (
                  <></>
                )}
                {qEntera && (qInferior || qSuperior || qBrassiere) ? (
                  <Col className="sizeguide-filter-button" xs={1}>
                    <PushButtonFilter
                      title={<FormattedMessage id="size-guide-entera" />}
                      quantity={qEntera}
                      StateFilter={isFilterEntire}
                      ClickSuscribe={onSearchEntera}
                    />
                  </Col>
                ) : (
                  <></>
                )}
                {qBrassiere && (qInferior || qEntera || qSuperior) ? (
                  <Col className="sizeguide-filter-button" xs={1}>
                    <PushButtonFilter
                      title={<FormattedMessage id="ready-size-bras" />}
                      quantity={qEntera}
                      StateFilter={isFilterBrassiere}
                      ClickSuscribe={onSearchBrassiere}
                    />
                  </Col>
                ) : (
                  <></>
                )}
                {qFemenino && qMasculino ? (
                  <Col className="sizeguide-filter-button" xs={1}>
                    <PushButtonFilter
                      title={<FormattedMessage id="ready-size-female" />}
                      quantity={qFemenino}
                      StateFilter={isFilterFemale}
                      ClickSuscribe={onSearchFemenino}
                    />
                  </Col>
                ) : (
                  <></>
                )}
                {qFemenino && qMasculino ? (
                  <Col className="sizeguide-filter-button" xs={1}>
                    <PushButtonFilter
                      title={<FormattedMessage id="ready-size-male" />}
                      quantity={qMasculino}
                      StateFilter={isFilterMale}
                      ClickSuscribe={onSearchMasculino}
                    />
                  </Col>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="size-guide-grid-search-excel-container">
              <InputSearch onInputChange={onSearch} />
              {props.handlerDownload ? (
                <Col className="excel-col-container">
                  <OverlayTrigger
                    key={`product-grid-export`}
                    placement={"top"}
                    overlay={
                      <Tooltip>
                        <FormattedMessage
                          id="export-tooltip"
                          defaultMessage="Exportar"
                        />
                      </Tooltip>
                    }
                  >
                    <Button
                      type="button"
                      variant="outline-success"
                      size="sm"
                      onClick={() => onClickDownload(selection)}
                    >
                      <FontAwesomeIcon icon={"file-excel"} />
                    </Button>
                  </OverlayTrigger>
                </Col>
              ) : (
                <></>
              )}
            </div>
          </div>
          {selection && selection.length > 1 && props.handlerDeleteGroup ? (
            <Col xs={3} className="size-guide-grid-delete-container">
              <div className="size-guide-grid-delete-button">
                <ButtomAction
                  label={`Borrar`}
                  eventClick={() => onClickDeleteGroup(selection)}
                ></ButtomAction>
              </div>
            </Col>
          ) : (
            <></>
          )}
        </Row>
      </>
    );
  };

  const renderRowEdit = (rowData: any, event: any) => {
    try {
      return (
        <>
          <div className={`text-center sizeguidegrid-buttons-1`}>
            <OverlayTrigger
              key={`edit-${rowData.Id}`}
              placement={"top"}
              overlay={
                <Tooltip>
                  <FormattedMessage id="edit-tooltip" defaultMessage="Edit" />
                </Tooltip>
              }
            >
              <Button
                type="button"
                variant="outline-light"
                className="rounded-circle"
                size="sm"
                onClick={() => onClickEdit(rowData)}
              >
                <FontAwesomeIcon icon={"pen"} className="text-dark" />
              </Button>
            </OverlayTrigger>
          </div>
        </>
      );
    } catch (error) {
      console.log(error);

      return <></>;
    }
  };

  const renderRowDuplicate = (rowData: any, event: any) => {
    try {
      return (
        <>
          <div className={`text-center sizeguidegrid-buttons`}>
            <OverlayTrigger
              key={`clone-${rowData.Id}`}
              placement={"top"}
              overlay={
                <Tooltip>
                  <FormattedMessage
                    id="duplicate-tooltip"
                    // defaultMessage="Duplicar"
                  />
                </Tooltip>
              }
            >
              <Button
                type="button"
                variant="outline-light"
                className="rounded-circle"
                size="sm"
                onClick={() => onClickClone(rowData)}
              >
                <FontAwesomeIcon icon={"clone"} className="text-dark" />
              </Button>
            </OverlayTrigger>
          </div>
        </>
      );
    } catch (error) {
      console.log(error);

      return <></>;
    }
  };

  const renderRowDelete = (rowData: any, event: any) => {
    try {
      return (
        <>
          <div className={`text-center sizeguidegrid-buttons`}>
            <OverlayTrigger
              key={`remove-${rowData.Id}`}
              placement={"top"}
              overlay={
                <Tooltip>
                  <FormattedMessage
                    id="delete-tooltip"
                    // defaultMessage="Borrar"
                  />
                </Tooltip>
              }
            >
              <Button
                type="button"
                variant="outline-light"
                className="rounded-circle"
                size="sm"
                onClick={() => onClickDelete(rowData)}
              >
                <FontAwesomeIcon icon={"trash-alt"} className="text-dark" />
              </Button>
            </OverlayTrigger>
          </div>
        </>
      );
    } catch (error) {
      console.log(error);

      return <></>;
    }
  };

  // const handleClick = (event: any, rowData: any) => {

  //   try {

  //     // event.preventDefault();

  //     if (!showOptions) {

  //       console.log('Menu handleClick SetTarget No', { event: event, target: event.target, data: rowData });

  //       setShowOptions(true);
  //       setTarget(event.target);
  //       setTargetDataProduct(rowData);

  //     } else {
  //       console.log('Menu handleClick SetTarget Si', { event: event, target: event.target, data: rowData });

  //       //
  //       setShowOptions(false);
  //       // setTarget(null);
  //       // setTargetDataProduct(null);
  //     }

  //   } catch (error) {
  //     console.log(error);
  //   }

  // };

  const renderSize = (rowData: any) => {
    try {
      if (rowData && rowData.Sizes) {
        return rowData.Sizes.map((element: any) => element.Name).join(", ");
      } else {
        return "";
      }
    } catch (error) {}
  };

  return (
    <>
      <div className="table-fitprenda-content">
        <DataTable
          value={elements}
          dataKey="Id"
          header={renderHeader()}
          responsiveLayout="scroll"
          scrollable
          scrollHeight={props.scrollHeight || "230px"}
          selectionMode="checkbox"
          selection={selection}
          onSelectionChange={(e: any) => onSelectionChange(e)}
          size="small"
          filters={filters}
          globalFilterFields={[
            "Id",
            "Name",
            "TypeSizeGuide.Name",
            "Gender.Name",
          ]}
          loading={props.isLoading || false}
        >
          {props.handlerSelectionRow ? (
            <Column
              selectionMode="multiple"
              headerStyle={{ width: "3em" }}
              style={{ maxWidth: "54px" }}
            ></Column>
          ) : null}
          <Column
            field="Id"
            header="#"
            sortable
            className="col-md-1 col-sm-2"
          ></Column>
          <Column
            field="Name"
            header={
              <FormattedMessage id="header-name" defaultMessage="Nombre" />
            }
            sortable
            className="col-md-4 col-sm-6"
          ></Column>
          <Column
            field="Gender.Name"
            header={
              <FormattedMessage
                id="ready-size-gender"
                defaultMessage="Género"
              />
            }
            sortable
            className="col-md-2 col-sm-4"
          ></Column>
          <Column
            field="TypeSizeGuide.Name"
            header={<FormattedMessage id="header-type" defaultMessage="Tipo" />}
            sortable
            className="col-md-2 col-sm-4"
          ></Column>
          <Column
            // field="Sizes"
            header={
              <FormattedMessage id="ready-size-sizes" defaultMessage="Talles" />
            }
            body={renderSize}
            // sortable
            className="col-md-3 col-sm-6"
          ></Column>
          <Column
            field="Related"
            header={
              <FormattedMessage
                id="header-related-products"
                defaultMessage="Productos asociados"
              />
            }
            body={(rowData) => {
              return (
                <>
                  <span className="w-100 text-center">{rowData.Related}</span>
                </>
              );
            }}
            sortable
            className="col-md-3 col-sm-6 text-center"
          ></Column>
          {/* ACA EMPIEZA EL DATO NUEVO */}
          <Column
            field="Status"
            header=""
            body={renderRowStatus}
            className="col-md-3 col-sm-6 text-center"
            bodyClassName="p-0"
            style={{ width: "100px" }}
          />
          {props.handlerEdit ? (
            <Column
              header=""
              body={(rowData: any, event: any) => renderRowEdit(rowData, event)}
              bodyClassName={`${
                !props.handlerClone && !props.handlerDelete ? "me-3" : ""
              }`}
              style={{
                maxWidth: "40px",
                minWidth: "20px",
              }}
              className="sizeguidegrid-icon"
            ></Column>
          ) : null}
          {props.handlerClone ? (
            <Column
              header=""
              body={(rowData: any, event: any) =>
                renderRowDuplicate(rowData, event)
              }
              bodyClassName={`${!props.handlerDelete ? "me-3" : ""}`}
              style={{
                maxWidth: "40px",
                minWidth: "20px",
              }}
            ></Column>
          ) : null}
          {props.handlerDelete ? (
            <Column
              header=""
              body={(rowData: any, event: any) =>
                renderRowDelete(rowData, event)
              }
              bodyClassName={`me-3`}
              style={{
                maxWidth: "40px",
                minWidth: "20px",
              }}
            ></Column>
          ) : null}
          {/* {
              ((props.handlerEdit) || (props.handlerClone) || (props.handlerDelete)) ?
                  <Column
                    header=""
                    body={(rowData: any, event: any) => renderActionRow(rowData, event)}
                    style={{ maxWidth: "35px", minWidth: "15px" }}></Column>
                  : <></>
            } */}
        </DataTable>
      </div>
    </>
  );
};

export default DataTableSizeGuides;
